import { WarningCircle } from '@phosphor-icons/react'
import React from 'react'
import DragDrop from '../../DragDrop'

export default function LandingInput({ onChange, error, loading }) {
  return (
    <div className="h-[220px] border-b-[1.5px] py-3">
      <div className="flex h-full ">
        {/* Left half: Upload area */}
        <div className="w-full ">
          <h2>Landing Photo</h2>
          <DragDrop
            onFilesUploaded={onChange}
            acceptedFileTypes={{
              "image/*": [".jpeg", ".png", ".jpg"],
            }}
            maxFiles={1}
            dragDropText="Drag and drop landing photo here"
          />
          {loading && (
            <span className="text-[#737880] text-xs">
              Uploading…
            </span>
          )}
          {error && (
            <span className="text-[#E47186] text-xs flex items-center gap-1">
              <WarningCircle className="text-sm" />
              {error}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
